'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';
import { Env } from '@/consts/Env';

export const Cookiebot = () => {
  const cookiebotId = Env.NEXT_PUBLIC_COOKIEBOT_ID;
  // Render the script only on the client: a server-rendered afterInteractive script adds a
  // <link rel="preload"> that competes with the LCP image. It still loads right after hydration.
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <Script
      id="cookiebot"
      strategy="afterInteractive"
      src="https://consent.cookiebot.com/uc.js"
      data-cbid={cookiebotId}
      // If something went wrong with cookiebot , see on this comment first
      // data-blockingmode="auto"
      type="text/javascript"
    />
  );
};
